import {FormikProps} from 'formik';
import DotsLoading from '../../../../components/dotsLoading';
import {getInputGroupByCode} from '../../../../module/dashboard/category/utilities';
import useGetInputLists from '../../../../services/hookService/getInputLists/useGetInputLists';
import {ShowFormError} from '../../../../utilities/helper/showFormError';
import InputItem from './InputItem';
import {IProductForm} from './productFormData';

interface Props {
  form: FormikProps<IProductForm>;
  isEditing?: boolean;
}

const SelectInput = ({form, isEditing}: Props) => {
  const inputGroupCode = Number(form.values.inputGroupCode);

  const {data, isLoading} = useGetInputLists({
    input_group__code: inputGroupCode,
  });

  return (
    <>
      <div
        className="text-gray-900 text-md"
        style={isEditing ? {pointerEvents: 'none', opacity: 0.6} : undefined}
      >
        <p className="mb-1 font-medium color-gray-1 text-md">
          نوع {getInputGroupByCode[form.values.inputGroupCode!]}{' '}
          <span className="text-red-500">*</span>
        </p>

        {!data || isLoading ? (
          <div className="grid place-content-center my-5">
            <DotsLoading />
          </div>
        ) : (
          <div className="grid grid-cols-4 gap-3 mt-4">
            {data?.map(input => (
              <InputItem
                key={input.guid}
                image={input.image!}
                title={input.title}
                code={input.code}
                guid={input.guid}
                form={form}
              />
            ))}
          </div>
        )}
      </div>

      <ShowFormError field="inputGuid" form={form} />
    </>
  );
};

export default SelectInput;
